import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const ServiceCard = ({ service }) => {
  const Icon = service.icon;
  const isContain = service.fit === "contain";
  return (
    <Card className="card-hover group flex h-full flex-col overflow-hidden border-border bg-card p-0">
      <div className={cn("relative aspect-[16/10] overflow-hidden", isContain && "bg-muted")}>
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className={cn(
            "h-full w-full transition-transform duration-500 group-hover:scale-105",
            isContain ? "object-contain p-3" : "object-cover"
          )}
        />
        {!isContain && (
          <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/55 to-transparent" />
        )}
        <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-yellow">
          <Icon className="h-5 w-5" />
        </div>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="text-xl font-bold text-foreground">{service.title}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">{service.short}</p>
        <Link
          to={`/services/${service.slug}`}
          className="mt-auto pt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-foreground transition-colors hover:text-accent"
        >
          Learn more
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </Card>
  );
};
